import React, { useEffect } from "react";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Modal from "../../../layout/Modal/Modal";
import ListBadge from "../../../layout/ListBadge";
import { dataProcesosElectoralesPJ } from "../../../data/dataProcesosElectoralesPJ";

const PE2024 = () => {

  useEffect(() => {
    document.title = `Proceso Electoral Poder Judicial`;
  }, []);

  return (
    <>
      <div className="margin-bottom-2">

        <NavbarEnlaces title="Resultados de Elecciones del Poder Judicial" />

        <div className="Content__grid">

          {dataProcesosElectoralesPJ.map((item) => (
            <div key={item.id}>
              <a
                href="/#"
                rel="noreferrer"
                data-bs-toggle="modal"
                data-bs-target={`#${item.idModal}`}
              >
                <img
                  className="img-fluid"
                  src="https://itetlax.org.mx/assets/img/icons/e21.png"
                  alt={item.alt}
                />
              </a>

              <p className="mt-2 small">{item.titulo}</p>
            </div>
          ))}

        </div>

        {/* MODALES */}

        {dataProcesosElectoralesPJ.map((item) => (
          <Modal
            key={item.id}
            idModal={item.idModal}
            titleModal={<span style={{ fontSize: "0.85rem" }}>{item.titulo}</span>}
            sizeModal=""
            contentModal={
              <ListBadge
                ifNumbered={""}
                listsBadgeItem={item.documentos}
              />
            }
          />
        ))}

      </div>
    </>
  );
};

export default PE2024;